import type { ReactNode } from 'react'

interface AuthCardProps {
  heading: string
  /** A hosted logo to show above the heading; omit for none. */
  logoUrl?: string
  children: ReactNode
}

/** The card the sign-in, forgot-password and reset-password pages share: heading, then the page's own content. */
export function AuthCard({ heading, logoUrl, children }: AuthCardProps) {
  return (
    <div className="mx-auto w-full max-w-90 rounded-card bg-white p-8 shadow-xl">
      <div className="flex flex-col items-center">
        {logoUrl && (
          <img
            src={logoUrl}
            alt="Codeverse"
            width={56}
            height={56}
            className="mb-3 object-contain"
          />
        )}
        <h1 className="text-3xl font-bold tracking-tight text-ink">{heading}</h1>
      </div>
      {children}
    </div>
  )
}
